var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VsPrompt',{ref:"prompt",attrs:{"title":_vm.title,"color":_vm.color,"acceptText":_vm.buttonText,"buttonAccept":_vm.buttonType},on:{"accept":_vm.accept,"close":_vm.close}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }